import { useEffect, useState } from 'react';

/** Return ``value`` after it has been stable for ``delayMs``.
 *
 *  Used by the SearchRow to avoid issuing an API request on every
 *  keystroke. Pattern: render the user-input value in the input, but
 *  feed the debounced value into ``useJobs(search: debounced)``.
 */
export function useDebounce<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
